import React, { Component } from "react";
import ListUser from "./List_pengguna";

class User extends Component {
    render() {
        return (
            <ListUser />
        );
    }
}

export default User;